import clsx from 'clsx';
import {InputHTMLAttributes} from 'react';
import {useI18n} from '../../../../common/providers/I18nProvider';

export type AuthFieldProps = {
	fieldProps: object;
	placeholder: string;
	isInvalid?: boolean;
} & Exclude<InputHTMLAttributes<string>, 'placeholder'>;

export const getInputClass = (isInvalid?: boolean) => {
	return clsx(
		'bg-white text-auth-black placeholder-gray-500 placeholder-opacity-50 border border-black-80 rounded-lg py-3 px-4 w-full h-[56px]',
		{
			'border-red-400': isInvalid,
		},
		'focus:outline-none focus:border-primary ',
	);
};

export default function InputField({type = 'text', fieldProps, placeholder, isInvalid}: AuthFieldProps) {
	const {i18n} = useI18n();
	return (
		<input
			placeholder={i18n(placeholder)}
			{...fieldProps}
			className={getInputClass(isInvalid)}
			type={type}
			autoComplete='off'
		/>
	);
}
